import React from "react";
import { Link, EmptyState, Flex } from "@jsq/ds/core";
import { useReportError } from "#common/hooks/useReportError";
import { useDistributionWorkflowContext } from "../../Context/context";
import { DistributionWorkflowStepProps } from "../../types";
import { errorStepContainer } from "./styles_vanilla.css";

const ErrorStep: React.FC<DistributionWorkflowStepProps> = () => {
  const { errorMessage } = useDistributionWorkflowContext();

  useReportError(errorMessage);

  return (
    <Flex className={errorStepContainer} alignItems="center" flexGrow={1}>
      <EmptyState
        illustration="document-failure"
        title="Payments batch not created"
        description={errorMessage}
      >
        <Link displayAsButton href="/canopy/treasury/transactions" variant="primary">
          Go to transactions dashboard
        </Link>
      </EmptyState>
    </Flex>
  );
};

export default ErrorStep;
